__turbopack_context__.v({
  "blocksBackgroundColor": "EventsBlock-module-scss-module__5RDp2W__blocksBackgroundColor",
  "blocksFontColor": "EventsBlock-module-scss-module__5RDp2W__blocksFontColor",
  "eventsBlock": "EventsBlock-module-scss-module__5RDp2W__eventsBlock",
  "eventsBlockWrapper": "EventsBlock-module-scss-module__5RDp2W__eventsBlockWrapper",
  "eventsTransitionWrapper": "EventsBlock-module-scss-module__5RDp2W__eventsTransitionWrapper",
  "secondaryNavBackgroundColor": "EventsBlock-module-scss-module__5RDp2W__secondaryNavBackgroundColor",
  "themeBackgroundColor": "EventsBlock-module-scss-module__5RDp2W__themeBackgroundColor",
  "themeFontColor": "EventsBlock-module-scss-module__5RDp2W__themeFontColor",
  "themeFontFamily": "EventsBlock-module-scss-module__5RDp2W__themeFontFamily",
  "toggleButtonsContainer": "EventsBlock-module-scss-module__5RDp2W__toggleButtonsContainer",
  "transitionAppear": "EventsBlock-module-scss-module__5RDp2W__transitionAppear",
  "transitionAppearActive": "EventsBlock-module-scss-module__5RDp2W__transitionAppearActive",
  "transitionAppearDone": "EventsBlock-module-scss-module__5RDp2W__transitionAppearDone",
  "transitionEnter": "EventsBlock-module-scss-module__5RDp2W__transitionEnter",
  "transitionEnterActive": "EventsBlock-module-scss-module__5RDp2W__transitionEnterActive",
  "transitionEnterDone": "EventsBlock-module-scss-module__5RDp2W__transitionEnterDone",
  "transitionExit": "EventsBlock-module-scss-module__5RDp2W__transitionExit",
  "transitionExitActive": "EventsBlock-module-scss-module__5RDp2W__transitionExitActive",
  "transitionExitDone": "EventsBlock-module-scss-module__5RDp2W__transitionExitDone",
});
